import functions from "./functions.js";

$(function () {

    const $form = $('.newsletter-form');
    const form = $form[0];

    const lang = functions.getLang();
    let output = '';

    if (!form) {
        return;
    }

    $form.on('submit', e => {
        e.preventDefault();

        $('.newsletter-btn').addClass('d-none');
        $('.contact-spinner').removeClass('d-none');
        $('.contact-spinner').addClass('d-flex');

        let params = {};
        $.each($form.serializeArray(), function (i, field) {
            params[field.name] = field.value;
        });

        params['language'] = functions.getLang();

        grecaptcha.ready(function () {
            grecaptcha.execute('6LfphqggAAAAAAsli7qz4-HH3vF2YCh-KLYX4qPT', { action: 'contact' }).then(function (token) {
                params['gRecaptchaToken'] = token;
                params = functions.getDataForUrl(params);
                $.post('/services/zoho_newsletter/', params).then(response => {
                    
                    response = JSON.parse(response);
                    $('#newsletter-modal').modal('show');
                    $(".response-output").html(response.data);

                    $('.newsletter-btn').removeClass('d-none');
                    $('.contact-spinner').removeClass('d-flex');
                    $('.contact-spinner').addClass('d-none');

                    setTimeout(() => { $('#newsletter-modal').modal('hide') }, 4000);

                    if (response.status == true) {
                        form.reset();
                    }
                });
            });
        });

    });

});